<div class="bg-gray-50 flex">
  <!-- Loader -->
  <app-loader *ngIf="loaderService.isLoading$ | async"></app-loader>

  <!-- Mobile overlay -->
  <div
    *ngIf="isSidebarOpen && showLayout"
    (click)="closeSidebar()"
    class="fixed inset-0 bg-opacity-50 z-30 lg:hidden"></div>

  <!-- Sidebar -->
  <div
    *ngIf="showLayout"
    [class.translate-x-0]="isSidebarOpen"
    [class.-translate-x-full]="!isSidebarOpen"
    class="w-64 bg-white shadow-sm border-r border-gray-200 fixed h-full z-40 transition-transform duration-300 lg:translate-x-0">
    <app-sidebar (linkClick)="closeSidebar()"></app-sidebar>
  </div>

  <!-- Main Content -->
  <div class="flex-1" [class.lg:ml-64]="showLayout">
    <!-- Mobile menu button -->
    <button
      *ngIf="showLayout"
      (click)="toggleSidebar()"
      class="lg:hidden fixed top-3 left-3 z-50 p-2 rounded-lg bg-white shadow-md border border-gray-200 hover:bg-gray-50">
      <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path *ngIf="!isSidebarOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
        <path *ngIf="isSidebarOpen" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>

    <!-- Header -->
    <app-header *ngIf="showLayout"></app-header>

    <!-- Page Content -->
    <main [class.p-3]="showLayout" [class.sm:p-6]="showLayout" [class.pt-16]="showLayout" [class.sm:pt-20]="showLayout">
      <div [@routeAnimation]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </main>
  </div>

  <!-- Notification Toast Container -->
  <div class="fixed top-4 right-4 z-[100] flex flex-col gap-2 max-w-sm">
    <div *ngFor="let notification of notifications"
         [class]="getNotificationClasses(notification.type)">
      <span class="flex-1">{{ notification.message }}</span>
      <button (click)="dismissNotification(notification.id)"
              class="ml-2 opacity-60 hover:opacity-100 transition-opacity text-lg leading-none">&times;</button>
    </div>
  </div>

  <!-- Site Selection Modal -->
  <app-site-selection-modal
    [isOpen]="showSiteSelectionModal"
    [allowDismiss]="siteSelectionAllowDismiss"
    (siteSelected)="onSiteSelected($event)"
    (cancelled)="onSiteSelectionCancelled()">
  </app-site-selection-modal>
</div>